import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useNavigate } from "react-router-dom";
import { submitSiteDelete } from "../../../utils/commonComponent/delete";
import { AddButton } from "../../../utils/Custom/Button";
import DownloadReportsModal from "./DownloadReportsModal";
import { fetchByTable, fetchQuery} from "../../../utils/commonComponent/fetched";
import ListSearchSection from "../../../utils/Custom/ListSearchSection";
import ListView from "../../../utils/Custom/listView";
import { getPermissions } from "../rbac/hasAccess";
import { HR_employeeStatus, employeeTypeOptions } from "./employeeConstants";

const headers = [
  "id",
  "employeesCode",
  "employeeType",
  "name",
  "designation",
  "dateOfJoining",
  "contactNumber",
  "emailAddress",
  "department",
  "branch",
  "employeeStatus"
];

const fields = [
  { value: "name", label: "Name" },
  { value: "employeesCode", label: "Employees Code" },
  { value: "designation", label: "Designation" },
  { value: "emailId", label: "Email Id" },
  { value: "contactNumber", label: "Contact Number" },

  { value: "department", label: "Department" },
  { value: "branch", label: "Branch" },
  { value: "employeeStatus", label: "Employee Status" },
];

const EmployeeMasterList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/master/employeeMasterEdit/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("employees", row.id);

  const [employeesList, setInspectorList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [allEmployeesData, setAllEmployeesData] = useState([]);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "name");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
  const _employeeId = Number(localStorage.getItem("employeeId"));
  const _userType = Number(localStorage.getItem("type"));
  const [downloadModalRow, setDownloadModalRow] = useState(false);

  // Pagination
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
  };

  const getWhereClause = () => {
    const colMap = {
      // employees table
      name: "e.name",
      employeesCode: "e.employeesCode",
      emailId: "e.emailId",
      contactNumber: "e.contactNumber",
      location: "e.location",

      // employeeOtherData table
      branch: "eod.branchId",
      department: "eod.department",
      designation: "eod.hrDesignation",
      employeeStatus: "eod.employeeStatus",
      employeeType: "eod.employeeType",
    };

    const colName = colMap[searchBy];
    const key = searchKey.trim().toLowerCase();

    let whereConditions = ["e.status = 1"];

    if (colName && key) {
    if (searchBy === "employeeStatus") {
      // Find all matching statuses (partial match)
      const matchedStatuses = HR_employeeStatus.filter((status) =>
        status.name.toLowerCase().includes(key)
      );
      if (matchedStatuses.length > 0) {
        const statusIds = matchedStatuses.map((s) => s.id).join(",");
        whereConditions.push(`${colName} IN (${statusIds})`);
      }
    } else {
      whereConditions.push(`${colName} LIKE '%${key}%'`);
    }
    }

    if (![1, 2, 3, 8].includes(_userType)) {
      whereConditions.push(`e.id = ${_employeeId}`);
    }

    return `WHERE ${whereConditions.join(" AND ")}`;
  };

  const getDataQuery = () => {
    const whereClause = getWhereClause();

    let paginationSettings = "";
    if (rowsPerPage !== -1) {
      paginationSettings = `LIMIT ${rowsPerPage} OFFSET ${
        rowsPerPage * Number(currentPage)
      }`;
    }

    return `SELECT e.*, eod.branchId as branch, eod.department, eod.hrDesignation as designation, eod.employeeStatus as employeeStatus, eod.employeeType as employeeType FROM employees e LEFT JOIN employeeOtherData eod ON eod.employeeId = e.id ${whereClause} ORDER BY e.id DESC ${paginationSettings};`;
  };

  const getCountQuery = () => {
    const whereClause = getWhereClause();

    return `SELECT COUNT(DISTINCT e.id) AS totalRows FROM employees e LEFT JOIN employeeOtherData eod ON eod.employeeId = e.id ${whereClause};`;
  };

   const fetchAllEmployeesData = () => {
     const whereClause = getWhereClause();

     return `SELECT e.*, eod.branchId as branch, eod.department, eod.hrDesignation as designation, eod.employeeStatus as employeeStatus, eod.employeeType as employeeType FROM employees e LEFT JOIN employeeOtherData eod ON eod.employeeId = e.id ${whereClause} ORDER BY e.id DESC;`;   
  };

  const fetchData = async () => {
    try {
      const dataQuery = getDataQuery();
      const countQuery = getCountQuery();
      const allDataQuery = fetchAllEmployeesData();

      const [userData, countResult, allData] = await Promise.all([
        fetchQuery(dataQuery),
        fetchQuery(countQuery),
        fetchQuery(allDataQuery),
      ]);

      let modifiedUserData = userData.map((item) => ({
        ...item,
        employeeStatus: HR_employeeStatus.find((status) => status.id == item.employeeStatus)?.name || "",
        employeeType: employeeTypeOptions.find((t) => t.id == item.employeeType)?.name || "",
      }));

      let modifiedUserallData = allData?.map((item) => ({
        ...item,
        employeeStatus: HR_employeeStatus.find((status) => status.id == item.employeeStatus)?.name || "",
        employeeType: employeeTypeOptions.find((t) => t.id == item.employeeType)?.name || "",
      }));

      setInspectorList(modifiedUserData);
      setTotalRows(countResult?.[0]?.totalRows || 0);
      setAllEmployeesData(modifiedUserallData);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("name");
    setSearchKey("");
    // Clear all employee list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

 

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-outline"
          to="/master/employeeMasterEdit/0"
          label="Add Employee"
          icon={<AddIcon fontSize="small" />}
        />
      )}
      <ListSearchSection
        title="Search Employee"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
        showExcelDownload={permissions.excelDownload || permissions.allAccess}
        finalData={allEmployeesData}
        notNeededColumn={["id", "profileImageUlr", "state","permenantAddress", "currentAddress", "dateOfBirth","maritalStatus", "alternativeContactNumber", "officeEmailAddress", "gender","bloodGroup","PrivilegedLeaveBase","status", "location", "password", "type", "leaveManagement_id", "employeeId"]}
      />

      <ListView
        headers={headers}
        data={employeesList}
        actions={{
          edit: handleEdit,
          delete: handleDelete,
          view1: (row) => navigate(`/master/employeeMasterPrint/${row.id}`),
          downloadReports: (row) => setDownloadModalRow(row),
        }}
        showCheckbox={true}
        deleteTableName={"employees"}
        moduleId={props.moduleId}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPaginationChange={handlePaginationChange}
      />

      {downloadModalRow && (
      <DownloadReportsModal
        open={!!downloadModalRow}
        employeeId={downloadModalRow.id}
        employeeName={downloadModalRow.name}
        onClose={() => setDownloadModalRow(null)}
      />
    )}
    </>
  );
};

export default EmployeeMasterList;